<template>
  <SectionSelectAssessment />
  <!-- <SectionLastActivities /> -->
  <!-- <SectionNews /> -->
  <!-- <SectionFaq /> -->
  <SectionComingSoon />
</template>

<script setup>
import SectionComingSoon from 'components/Admin/Home/SectionComingSoon.vue'
import SectionFaq from 'components/Admin/Home/SectionFaq.vue'
import SectionLastActivities from 'components/Admin/Home/SectionLastActivities.vue'
import SectionNews from 'components/Admin/Home/SectionNews.vue'
import SectionSelectAssessment from 'components/Admin/Home/SectionSelectAssessment.vue'
</script>

<style lang="scss" scoped></style>
